import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import classNames from 'classnames';
import Container from "@scentregroup/ui/components/container";
import Heading from "@scentregroup/ui/components/heading";
import ResponsiveImage from '../responsive-image';
import Image from '../image';
import { CustomThemeContext } from '../../context';
import Trackable from '../trackable';
import { trackingActions, trackingTypes } from '../../constants';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PageLanding = _ref => {
  let {
    desktopImage,
    mobileImage,
    heading,
    logo,
    children,
    dataTestId,
    imageDataTestId,
    analyticsMetadata
  } = _ref;
  return /*#__PURE__*/_jsx(CustomThemeContext.Consumer, {
    children: themeOption => /*#__PURE__*/_jsx(Trackable, _objectSpread(_objectSpread({
      trackingAction: trackingActions.viewPromotion,
      type: trackingTypes.promotion
    }, analyticsMetadata), {}, {
      "data-id": "page-landing_index_PageLanding_Trackable",
      children: /*#__PURE__*/_jsxs("div", {
        className: style.evolved,
        "data-id": "page-landing_index_PageLanding_Trackable_div",
        children: [heading && /*#__PURE__*/_jsx(Container, {
          type: "large",
          className: style.heading,
          "data-id": "page-landing_index_PageLanding_Container",
          children: /*#__PURE__*/_jsx(Heading, {
            type: "medium",
            "data-test-id": dataTestId,
            "data-id": "page-landing_index_PageLanding_Container_Heading",
            children: heading
          })
        }), /*#__PURE__*/_jsx("div", {
          className: classNames(style.pagelanding, {
            [style.withLogo]: Boolean(logo),
            [style.withHeading]: Boolean(heading),
            [style.Grey]: themeOption.luxury
          }),
          "data-id": "page-landing_index_PageLanding_div_div",
          children: /*#__PURE__*/_jsxs("div", {
            className: style.featureWrapper,
            "data-id": "page-landing_index_PageLanding_div_div_5",
            children: [Boolean(desktopImage.src || mobileImage.src) && /*#__PURE__*/_jsx(ResponsiveImage, {
              lazyLoad: false,
              className: style.feature,
              angleOrigin: null,
              desktopImageUrl: desktopImage.src,
              mobileImageUrl: mobileImage.src,
              mobileRatio: "standard",
              desktopRatio: "feature",
              numberOfItems: 1,
              dataTestId: imageDataTestId,
              alt: desktopImage.alt || mobileImage.alt || '',
              "data-id": "page-landing_index_PageLanding_ResponsiveImage"
            }), logo && /*#__PURE__*/_jsx(Image, {
              className: style.logo,
              imageUrl: logo,
              ratio: "square",
              bgSize: "contain",
              alt: heading,
              "data-id": "page-landing_index_PageLanding_Image"
            }), /*#__PURE__*/_jsx(Container, {
              centred: true,
              type: "large",
              className: style.container,
              "data-id": "page-landing_index_PageLanding_div_Container",
              children: children
            })]
          })
        })]
      })
    }))
  });
};
PageLanding.defaultProps = {
  desktopImage: {
    alt: null,
    src: null
  },
  mobileImage: {
    alt: null,
    src: null
  }
};
export default PageLanding;